import SelectableList from '../../components/common/SelectableList';
import styled from 'styled-components';

const PublishSeriesList = styled(SelectableList)`
  height: 16.5625rem;
  overflow-y: auto;
`;

export default PublishSeriesList;
